// extracted by mini-css-extract-plugin
export default {"newFormUsersOnly":"UpdateUserProfile_newFormUsersOnly__u2veI"};